var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiusarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 48,
    viewBox: "0 0 158 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44262 19.0439C0.362684 19.9042 0.184625 21.4771 1.04492 22.557C1.90521 23.6369 3.47807 23.815 4.55801 22.9547L1.44262 19.0439ZM151.332 47.7654C152.699 47.962 153.966 47.0135 154.163 45.6468L157.367 23.3762C157.563 22.0095 156.615 20.7422 155.248 20.5456C153.882 20.349 152.614 21.2975 152.418 22.6641L149.57 42.4603L129.774 39.6122C128.407 39.4156 127.14 40.3641 126.943 41.7307C126.746 43.0974 127.695 44.3646 129.062 44.5613L151.332 47.7654ZM4.55801 22.9547C18.7265 11.6679 44.5515 3.55968 72.1984 5.39265C99.7411 7.21871 128.808 18.8931 149.687 46.7888L153.69 43.7928C131.788 14.5297 101.26 2.30847 72.5292 0.403606C43.9021 -1.49435 16.7735 6.83115 1.44262 19.0439L4.55801 22.9547Z",
    fill: "#C53EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiusarrow);
export default __webpack_public_path__ + "static/media/radiusarrow.dba15d3d4db2e2704143cb499af72a81.svg";
export { ForwardRef as ReactComponent };